export default "__VITE_ASSET__69b11161__"